module.exports = __webpack_public_path__ + "img/125.5cd58578.png";